import JournalingLoadingScreen from '@/components/ai-journaling/journal-entry-flow/loading-screen';
import { Box, SxProps, Theme } from '@rhg/libs/material';

const styleOverlay: SxProps<Theme> = {
    position: 'fixed',
    inset: 0,
    zIndex: (theme: Theme) => theme.zIndex.modal,
};

interface JournalingTransitionOverlayProps {
    isOpen: boolean;
}

export function JournalingTransitionOverlay({
    isOpen,
}: JournalingTransitionOverlayProps) {
    if (!isOpen) return null;
    return (
        <Box sx={styleOverlay} data-testid="journaling-transition-overlay">
            <JournalingLoadingScreen />
        </Box>
    );
}

export default JournalingTransitionOverlay;
